import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withClientConfig } from '@spotahome/bff/client';

import StaticMapsApi from '../api/static-maps-api';

const MARKER_PATH =
  'http://static-pages-assets.s3.amazonaws.com/marker-selected.png';
const POI_MARKER_PATH =
  'http://static-pages-assets.s3.amazonaws.com/marker-point-of-interest.png';

const withStaticMap = WrappedComponent =>
  withClientConfig()(
    class StaticMap extends Component {
      static propTypes = {
        coords: PropTypes.arrayOf(PropTypes.number).isRequired,
        size: PropTypes.string.isRequired,
        pointOfInterest: PropTypes.shape({
          lat: PropTypes.number,
          lng: PropTypes.number
        }),
        clientConfig: PropTypes.shape({
          googleMapsApiKey: PropTypes.string.isRequired
        }).isRequired
      };

      componentWillMount() {
        const key = this.props.clientConfig.googleMapsApiKey;
        const mapOpts = { key };

        if (this.props.size) {
          mapOpts.size = this.props.size;
        }

        this.staticMap = new StaticMapsApi('property-static-map', mapOpts);

        if (this.props.coords) {
          this.staticMap.addMarker('property', {
            lat: this.props.coords[1],
            lng: this.props.coords[0],
            icon: MARKER_PATH
          });
          this.staticMap.setCenter({
            lat: this.props.coords[1],
            lng: this.props.coords[0]
          });
        }

        if (this.props.pointOfInterest) {
          this._addPlace(this.props.pointOfInterest);
        } else {
          this._removePlace();
        }
      }

      componentWillReceiveProps(nextProps) {
        if (this.props !== nextProps) {
          if (nextProps.pointOfInterest) {
            this._addPlace(nextProps.pointOfInterest);
          } else {
            this._removePlace();
          }
        }
      }

      _addPlace(pointOfInterest) {
        this.staticMap.addMarker('place', {
          lat: pointOfInterest.lat,
          lng: pointOfInterest.lng,
          icon: POI_MARKER_PATH
        });
      }

      _removePlace() {
        this.staticMap.removeMarker('place');
      }

      _generateMapProps() {
        return this.props.coords
          ? { mapImage: this.staticMap.generateURL() }
          : {};
      }

      render() {
        return (
          <WrappedComponent {...this.props} {...this._generateMapProps()} />
        );
      }
    }
  );

export const SMALL_MAP = '315x290';
export default withStaticMap;
